import { useState, useEffect } from 'react';
var useFetchUserFromList = function (userId, list) {
    var _a = useState(false), user = _a[0], setUser = _a[1];
    useEffect(function () {
        var foundUser = list.find(function (user) { return user.user_id === userId; });
        setUser(foundUser || false);
    }, [userId, list]);
    return user;
};
export default useFetchUserFromList;
